import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSuppliesEquipment = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#cbabab",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.6667 4.26669L11.9916 2.91585C11.914 2.7608 11.7948 2.63042 11.6473 2.53931C11.4998 2.4482 11.3299 2.39997 11.1565 2.40002H7.64347C7.47011 2.39997 7.30016 2.4482 7.15268 2.53931C7.00519 2.63042 6.88599 2.7608 6.80844 2.91585L6.13333 4.26669H1.93333C1.6858 4.26669 1.4484 4.36502 1.27337 4.54006C1.09833 4.71509 1 4.95249 1 5.20002V12.6667C1 12.9142 1.09833 13.1516 1.27337 13.3267C1.4484 13.5017 1.6858 13.6 1.93333 13.6H14.0667C14.3142 13.6 14.5516 13.5017 14.7266 13.3267C14.9017 13.1516 15 12.9142 15 12.6667V5.20002C15 4.95249 14.9017 4.71509 14.7266 4.54006C14.5516 4.36502 14.3142 4.26669 14.0667 4.26669H12.6667Z",
			fill: "currentColor",
			fillOpacity: .25,
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.39997 11.1764C10.1186 11.1764 10.8078 10.8909 11.316 10.3827C11.8241 9.87459 12.1096 9.18538 12.1096 8.46673C12.1096 7.74809 11.8241 7.05888 11.316 6.55072C10.8078 6.04256 10.1186 5.75708 9.39997 5.75708C8.68132 5.75708 7.99211 6.04256 7.48395 6.55072C6.9758 7.05888 6.69032 7.74809 6.69032 8.46673C6.69032 9.18538 6.9758 9.87459 7.48395 10.3827C7.99211 10.8909 8.68132 11.1764 9.39997 11.1764Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.49047 6.9226C3.42858 6.9226 3.36923 6.89802 3.32548 6.85426C3.28172 6.8105 3.25713 6.75115 3.25713 6.68927C3.25713 6.62738 3.28172 6.56803 3.32548 6.52427C3.36923 6.48052 3.42858 6.45593 3.49047 6.45593",
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.49041 6.9226C3.55229 6.9226 3.61164 6.89802 3.6554 6.85426C3.69916 6.8105 3.72374 6.75115 3.72374 6.68927C3.72374 6.62738 3.69916 6.56803 3.6554 6.52427C3.61164 6.48052 3.55229 6.45593 3.49041 6.45593",
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.8 4.26671V3.33337",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgSuppliesEquipment;
